

































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */
import { Vue, Component, Prop } from "vue-property-decorator";
import { OrderActions } from "@/store/modules/order/types";
import { StoreModule } from "@/store/types";
import { namespace } from "vuex-class";
import { GlobalActions } from "@/store/modules/global/types";
@Component
export default class ConfirmClearCustomer extends Vue {
  @(namespace(StoreModule.Order).Action(OrderActions.ClearCustomer))
  clearCustomer!: () => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  clearOrder!: () => Promise<void>;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: number) => Promise<void>;

  protected closeModal(): void {
    this.$emit("close");
  }

  protected async removeCustomer(): Promise<void> {
    await this.clearCustomer();
    await this.addMultiplier(1);
    this.$emit("close");
  }

  protected async clearAll(): Promise<void> {
    this.$emit("clearOrder");
    await this.clearOrder();
    await this.clearCustomer();
    await this.addMultiplier(1);
    this.$emit("close");
  }
}
